import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */
const { Types, Creators } = createActions({
  expandCourse: ['id'],
});
export const DashboardTypes = Types;
export default Creators;

/* Initial State */
export const INITIAL_STATE = Immutable({
  expandedCourse: 0,
});

/* Reducers */
const expandCourse = (state = INITIAL_STATE, { id }) => ({
  ...state,
  expandedCourse:
    state.expandedCourse === id ? INITIAL_STATE.expandedCourse : id,
});

/* Reducers to types */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.EXPAND_COURSE]: expandCourse,
});
